import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import ThemeToggle from './components/ThemeToggle'; 
import PlayerLineChart from './components/PlayerLineChart';
import PlayerBarChart from './components/PlayerBarChart';
import './App.css';

function App() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <LanguageSelector />
      <ThemeToggle />
      <h1 className="dashboard-title">{t('title')}</h1>

      <Router>
        <nav style={{ marginBottom: '2rem' }}>
          <Link to="/" style={{ marginRight: '1rem' }}>📈 {t('chart1')}</Link>
          <Link to="/assists">📊 {t('chart2')}</Link>
        </nav>

        <Routes>
          <Route path="/" element={
            <div className="chart-section">
              <PlayerLineChart />
            </div>
          } />
          <Route path="/assists" element={
            <div className="chart-section">
              <PlayerBarChart />
            </div>
          } />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
